<template>
  <div id="billing-report">

    <!-- billing filter -->

    <!--
    <div class="billing-filters">
      <Filter icon="view-boards-filled" label="Selecionar Grupos" data="7/10"/>
      <Filter icon="view-grid-filled" label="Selecionar Projeto" data="Projeto"/>
      <Filter icon="archive-filled" label="Selecionar Produtos" data="10/10"/>
      <Filter icon="currency-dollar-filled" label="Empresa" data="Ativos S.A"/>
    </div>
    -->

    <!-- end billing filter -->

    <!-- CHARTS -->

    <!--
    <div class="chart-container">
      <div style="margin-right: 10px" class="chart"></div>
      <div style="margin-left: 10px" class="chart"></div>
      <div style="margin-top: 20px; width: calc(100% - 2px) !important;" class="chart"></div>
    </div>
    -->

    <!-- END CHARTS -->

    <!-- FILTERS -->

    <div class="table-filter-container">
      <div class="table-filters">

        <table class="filter-table-section">
          <tr>
            <td><Filter icon="calendar-filled" label="Empresa" data="All"/></td>
            <td><Filter icon="calendar-filled" label="Período Inicial" data="Jan 2022"/></td>
            <td><Filter icon="calendar-filled" label="Período Final" data="Fev 2022"/></td>
            <td><Filter icon="calendar-filled" label="Projeto" data="All"/></td>
            <td><Filter icon="calendar-filled" label="Ambiente" data="Detailed Billing"/></td>
            <td><Filter icon="calendar-filled" label="Grupo" data="Detailed Billing"/></td>
            <td><Filter icon="calendar-filled" label="Produto" data="Detailed Billing"/></td>
            <td><Filter icon="calendar-filled" label="Dt. Referência (USN)" data="[01/06/2021] R$ 3.26"/></td>
          </tr>

          <tr>

            <template v-if="showMoreFilters">
              <td colspan="2"><Filter icon="calendar-filled" label="Filtro" data="Exemplo"/></td>
              <td><Filter icon="calendar-filled" label="Filtro" data="Exemplo"/></td>
              <td><Filter icon="calendar-filled" label="Filtro" data="Exemplo"/></td>
              <td><Filter icon="calendar-filled" label="Filtro" data="Exemplo"/></td>
            </template>

            <td :colspan="showMoreFilters ? 3 : 8">
              <div :class="{ 'filter-actions': true, 'filter-actions-compressed': !showMoreFilters }">

                <div class="filter-option-container">
                  <div @click="toggleColumnOptions()"
                       v-bind:class="{
                          'filter-option': true,
                          'select-shadow': true,
                          'filter-option-active': showColumnOptions
                       }">
                    <div class="filter-icon">
                      <Icon type="table-filled"/>
                    </div>
                    <span class="filter-label">Colunas:</span>
                    <span class="filter-data">{{getActiveColumnsLength()}}/{{getColumnsLength()}}</span>
                  </div>

                  <div v-if="showColumnOptions" class="filter-expanded shadow-4">
                    <div class="search-bar">
                      <div class="search-container">
                        <div class="icon-container">
                          <Icon type="search"/>
                        </div>
                        <input type="text" placeholder="Buscar..."/>
                      </div>
                    </div>

                    <div class="list-container">
                      <div v-for="column in getColumns()"
                           @click="toggleColumn(column.key)"
                           class="list-item">
                        <input v-bind:id="column.key" type="checkbox" v-bind:checked="column.active"/>
                        <span>{{column.label}}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <AppButton label="Gerar Relatório" />
                <AppButton class="app-button-light" label="Limpar Filtros" />

                <div class="link-container">
                  <a @click="toggleMoreFilters">{{showMoreFilters ? 'Esconder' : 'Mais'}} filtros</a>
                  <a>Favoritar seleção</a>
                </div>
              </div>
            </td>
          </tr>
        </table>

      </div>
    </div>

    <hr style="margin-top: 14px" class="billing-horizontal-rule"/>

    <!-- END FILTERS -->

    <div class="table-content">

      <div class="table-head-container">
        <div class="thc-row">
          <template v-for="data in getColumns()">
            <div v-if="data.active"
                 v-bind:class="{ 'thc-cell': true, 'table-cell-right-text': data.pullRight  }"
                 v-bind:style="{ 'max-width': data.width || '0', 'min-width': data.width, 'width': data.width,  }">
              {{data.label}}
            </div>
          </template>
        </div>
      </div>

      <div class="billing-table-container">
        <div class="billing-table">
          <!--
          <div class="billing-table-row billing-table-head">
            <template v-for="data in getColumns()">
              <div v-if="data.active"
                   v-bind:class="{ 'billing-table-cell': true }"
                   v-bind:style="{ 'max-width': data.width || '0' }">
                {{data.label}}
              </div>
            </template>
          </div>
          -->

          <template v-for="group in billingReports.groups">
            <!-- billing-table-sub-head -->
            <div v-for="innerData in group.data" class="billing-table-row">
              <div v-if="isColumnActive('COST_SKU')" class="billing-table-cell" style="min-width: 120px; width: 120px">{{group?.cost_product_sku}}</div>
              <div v-if="isColumnActive('REFERENCE_DATE')" class="billing-table-cell"></div>
              <div v-if="isColumnActive('CREATION_DATE')" class="billing-table-cell">{{innerData?.dt_criacao}}</div>
              <div v-if="isColumnActive('ENVIRONMENT')" class="billing-table-cell"></div>
              <div v-if="isColumnActive('TAG_SKU')" class="billing-table-cell"></div>
              <div v-if="isColumnActive('PRODUCT_SERVICE')" class="billing-table-cell">{{innerData?.name_product_resource_id}}</div>
              <div v-if="isColumnActive('NAME_SKU')" class="billing-table-cell">{{group?.name_cost_product_sku}}</div>
              <div v-if="isColumnActive('SHAPE')" class="billing-table-cell">{{innerData?.shape}}</div>
              <div v-if="isColumnActive('MEM')" class="billing-table-cell">{{innerData?.mem}}</div>
              <div v-if="isColumnActive('VCPU')" class="billing-table-cell">{{innerData?.vcpu}}</div>
              <div v-if="isColumnActive('DISCO')" class="billing-table-cell">{{innerData?.performance}}</div>
              <div v-if="isColumnActive('GB')" class="billing-table-cell">{{innerData?.armazenamento}}</div>
              <div v-if="isColumnActive('DEVICE_HOURS')" class="billing-table-cell">{{innerData?.qtd_horas_dispositivos}}</div>
              <div v-if="isColumnActive('DEVICE_QUANTITY')" class="billing-table-cell"></div>
              <div v-if="isColumnActive('UP_FRONT')" class="billing-table-cell">{{group?.up_front}}</div>
              <div v-if="isColumnActive('ON_DEMAND')" class="billing-table-cell">{{group?.on_demand}}</div>
              <div v-if="isColumnActive('USN')" class="billing-table-cell table-cell-right-text">{{group?.usn}}</div>
              <div v-if="isColumnActive('USN_QUANTITY')" class="billing-table-cell">{{innerData?.qtd_usn}}</div>
              <div v-if="isColumnActive('TOTAL')" class="billing-table-cell">R$ {{innerData?.preco_final}}</div>
            </div>
          </template>

        </div>
      </div>

    </div>

    <div class="export-options">
      <AppButton label="Exportar" />
    </div>

  </div>
</template>

<script src="./BillingReport.js"/>
<style scoped src="./BillingReport.scss" lang="scss"/>